import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber, FormattedMessage} from 'react-intl';

import '../../../../styles/rounded-price.scss';

const RoundedPrice = ({currency, amount}) => {
  return (
    <span className="roundedPrice">
      <span className="price">
        <FormattedNumber
          style="currency"
          maximumFractionDigits={0}
          minimumFractionDigits={0}
          currencyDisplay="symbol"
          currency={currency}
          useGrouping
          value={amount}
        />
      </span>

      <span className="unit">
        /
        <FormattedMessage id="price.unit" defaultMessage="ea" />
      </span>
    </span>
  );
};

RoundedPrice.propTypes = {
  /** The currency of the price. */
  currency: PropTypes.string.isRequired,

  /** The amount of the price. */
  amount: PropTypes.number.isRequired,
};

export default RoundedPrice;
